module.exports = __webpack_public_path__ + "assets/microsoft-visual-studio.06d45283.svg";